import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

interface STORAGE_ADMIN {
    email?:string,
    expire?:number,
    username?:string
}

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }
    canActivate() {
        // localStorage.setItem('admin_login', JSON.stringify(
        //     {
        //         email:'tony@tonercity.com.au',
        //         expire:20000000,
        //         username:'Tony'
        //     }
        // ));
        // return true;
        if (localStorage.getItem('admin_login')) {
            console.log(localStorage.getItem('admin_login'));
            try {
                let admin:STORAGE_ADMIN = <STORAGE_ADMIN> JSON.parse(localStorage.getItem('admin_login'));
                console.log('admin', admin);
                let now = (new Date()).getTime()/1000;
                if (admin && admin.email) {
                    if(admin.expire > now) {
                        return true;
                    }
                }
            } catch(e) {
                console.log(e)
            }
        }

        this.router.navigate(['/login']);
        return false;
    }
}
